import "./TastingTours.module.css";
import EstateHeader from "@/reusable_sections/Header";
import VisitTheEstate from "./sections/VisitTheEstate";
import TourPackages from "./sections/TourPackages";
import ReserveYourVisit from "./sections/ReserveYourVisit";
import EstateFooter from "@/reusable_sections/Footer";
export default function TastingToursPage() {
  return <div>
      <EstateHeader />
      <VisitTheEstate />
      <TourPackages />
      <ReserveYourVisit />
      <EstateFooter />
    </div>;
}